import { Box, getThemeColor, ThemeColors } from '@fairfashion/design-system'
import { Handle } from 'reactflow'
import { styled } from 'styled-components'

export const Node = styled(Box)`
  width: 220px;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing['2']};
  background: ${({ theme }) => getThemeColor('white', theme)};
  border-radius: 8px;
  padding: 12px;
  pointer-events: all;
  border: 2px dashed ${({ theme }) => getThemeColor('purple', theme)}66;

  cursor: pointer;

  transition: all 0.3s;

  &:hover {
    background: ${({ theme }) => getThemeColor('grey_5', theme)};
  }
`

export const SegmentText = styled.small<{ color: string }>`
  font-size: 10px;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  text-align: left;
  gap: 0.25rem;

  & span {
    display: block;
    aspect-ratio: 1/1;
    width: 6px;
    height: 6px;
    background: ${(props) => props.color};
    border-radius: 50%;
  }
`

export const SmallText = styled.small<{ color?: ThemeColors }>`
  font-size: 10px;
  text-align: left;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px 0;

  color: ${(props) =>
    props.color
      ? getThemeColor(props.color, props.theme)
      : props.theme.colors.grey_1};
`

export const BoldText = styled.p`
  text-align: left;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.grey_1};
  font-weight: 500;
`

export const CustomHandle = styled(Handle)`
  min-height: 0;
  height: 0;
  opacity: 0;
`

export const VirtualTag = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  background: ${({ theme }) => getThemeColor('purple', theme)}22;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 10px;
  color: ${({ theme }) => getThemeColor('purple', theme)};
`
